import React, { useEffect, useState } from 'react';
import { List } from './List';
import { MenuSection } from '../SelectMenu/MenuSection';
import { MdCelebration } from 'react-icons/md';
import './promociones.css';

const capitalizeFirstLetter = (text) => {
  if (typeof text !== 'string') return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

// Función para calcular el costo por persona según la cantidad de personas y las tarifas disponibles
// const calcularCostoPorPersona = (numPersonas, tarifas) => {
//   if (!tarifas || tarifas.length === 0) return 0; // Si no hay tarifas, devolver 0.

//   // Ordenar tarifas por cantidad mínima de personas
//   const tarifasOrdenadas = [...tarifas].sort((a, b) => a.cantidadMinima - b.cantidadMinima);

//   // Buscar la tarifa adecuada según la cantidad de personas
//   const tarifaSeleccionada = tarifasOrdenadas.find(tarifa => 
//     numPersonas >= tarifa.cantidadMinima && numPersonas <= tarifa.cantidadMaxima
//   );

//   // Si encontramos una tarifa válida, usamos ese precio. Si no, tomamos el mínimo disponible.
//   return tarifaSeleccionada ? tarifaSeleccionada.costoPorPersona : tarifasOrdenadas[0].costoPorPersona;
// };

const calcularCostoPorPersona = (numPersonas, tarifas) => {
  if (!tarifas || tarifas.length === 0) return 0; // Si no hay tarifas, devolver 0.

  // Ordenar tarifas por cantidad mínima de personas
  const tarifasOrdenadas = [...tarifas].sort((a, b) => a.cantidadMinima - b.cantidadMinima);

  // Buscar la tarifa adecuada según la cantidad de personas
  const tarifaSeleccionada = tarifasOrdenadas.find(tarifa => 
    numPersonas >= tarifa.cantidadMinima && numPersonas <= tarifa.cantidadMaxima
  );

  // Si encontramos una tarifa válida, usamos ese precio.
  if (tarifaSeleccionada) return tarifaSeleccionada.costoPorPersona;

  // 🔹 Buscar la tarifa más cercana por debajo (para cubrir los intervalos vacíos)
  let tarifaAnterior = null;
  for (const tarifa of tarifasOrdenadas) {
    if (numPersonas > tarifa.cantidadMaxima) {
      tarifaAnterior = tarifa;
    } else {
      break;
    }
  }

  return tarifaAnterior ? tarifaAnterior.costoPorPersona : tarifasOrdenadas[0].costoPorPersona;
};


export const PromotionSections = ({ basicData }) => {
  const [openSections, setOpenSections] = useState([]);
  const paquete = basicData[0] || {}; // Tomar el primer paquete
  const { tarifas, serviciosIncluidos, serviciosComida, serviciosRecomendados, comidas, promocionesPaquete } = paquete;

  console.log("Esto es promociones prmotion", promocionesPaquete)
  
  const setServicesData = { serviciosIncluidos, serviciosComida, serviciosRecomendados, tarifas, promocionesPaquete };

 // Ordenar las tarifas por cantidad mínima y máxima de personas
 const tarifasOrdenadas = tarifas ? [...tarifas].sort((a, b) => a.cantidadMinima - b.cantidadMinima) : [];

 // Obtener el mínimo de personas desde las tarifas
 const minPersonas = tarifasOrdenadas.length > 0 ? tarifasOrdenadas[0].cantidadMinima : Infinity;
 const maxPersonas = tarifasOrdenadas.length > 0 ? tarifasOrdenadas[tarifasOrdenadas.length - 1].cantidadMaxima : Infinity;

  // Estado para el número de personas y alertas
  const [peopleCount, setPeopleCount] = useState(minPersonas);
  const [alertMessage, setAlertMessage] = useState('');

  // Estado para el costo por persona
  const [costoPorPersona, setCostoPorPersona] = useState(() => calcularCostoPorPersona(minPersonas, tarifas));

  // Actualizar el costo por persona cuando cambie el número de personas
  useEffect(() => {
    setCostoPorPersona(calcularCostoPorPersona(peopleCount, tarifas));
  }, [peopleCount, tarifas]);

  const handleToggleSection = (sectionIndex) => {
    setOpenSections((prevOpenSections) =>
      prevOpenSections.includes(sectionIndex)
        ? prevOpenSections.filter((index) => index !== sectionIndex)
        : [...prevOpenSections, sectionIndex]
    );
  };

  const handlePeopleCountChange = (event) => {
    const value = event.target.value; // No convertimos a número inmediatamente
    let message = '';
  
    if (value === '') {
      // Permitir que el usuario borre el campo completamente
      setPeopleCount('');
      setAlertMessage('');
      return;
    }
  
    const numericValue = Number(value);
  
    if (!isNaN(numericValue)) {
      if (numericValue < minPersonas) {
        message = `El mínimo es ${minPersonas} personas.`;
      } else if (numericValue > maxPersonas) {
        message = `El máximo es ${maxPersonas} personas.`;
      } else {
        message = '';
      }
      setPeopleCount(numericValue);
    }
  
    setAlertMessage(message);
  };
  

  // Filtrar datos duplicados
  const uniqueBasicData = basicData.filter((value, index, self) =>
    index === self.findIndex((t) => t.nombre === value.nombre && t.costoPorPersona === value.costoPorPersona)
  );

  return (
    <div className="promociones">
      <div className="type-list menu-section package">
        {uniqueBasicData.map((item, index) => (
          <div key={index}>
            <div className="section-header" onClick={() => handleToggleSection(index)}>
              <span className="section-title">
                <MdCelebration className="detail-icon-promotion celebration" />
                {capitalizeFirstLetter(item.nombre)}
              </span>
              {minPersonas === 0 ? (
                  <span className="section-price">
                    ${costoPorPersona} MXN hasta por {maxPersonas} personas
                  </span>
                ) : (
                  <span className="section-price">
                    ${costoPorPersona} MXN por persona
                  </span>
              )}
            </div>
            {openSections.includes(index) && (
                minPersonas === 0 ? (
                  <div className="pricing-info">

                    <p className="package-description">{item.descripcion}</p>

                    <div className="right-column">
                    <div className="tarifas-section">
                      <h4 style={{ textAlign: 'center' }}><strong>Ideal para eventos personalizados y totalmente a tu medida.</strong></h4>
                      <table className="tarifas-table">
                        <thead>
                          <tr>
                            <th colSpan="2">Detalles del paquete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>Capacidad máxima:</strong></td>
                            <td>hasta {maxPersonas} personas</td>
                          </tr>
                          <tr>
                            <td><strong>Costo base del salón:</strong></td>
                            <td>${costoPorPersona} MXN</td>
                          </tr>
                          <tr>
                            <td><strong>Servicios adicionales:</strong></td>
                            <td>Contratación independiente según tus necesidades</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    </div>


                    <div className="paquete-descripcion">
                      <h3>🎉 Diseñado para adaptarse a ti! </h3>
                      <p>
                        Este paquete incluye únicamente la renta del lugar, y te da la libertad de agregar solo los servicios que desees.
                      </p>
                      <p>
                        Los <strong>alimentos, bebidas y servicios</strong> se contratan por separado, lo que te permite personalizar cada detalle de tu evento.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="pricing-info">
                    <p className="package-description">{item.descripcion}</p>
                    <div className="people-container">

                      <div className="people-selector left-column">
                        <label htmlFor="people-count">Número de personas:</label>
                        <input
                          id="people-count"
                          type="number"
                          min={minPersonas}
                          max={maxPersonas}
                          value={peopleCount}
                          onChange={handlePeopleCountChange}
                        />
                        {alertMessage && <p className="alert-message">{alertMessage}</p>}

                        <h4>
                          <strong>Precio por persona:</strong> ${costoPorPersona} MXN
                        </h4>
                        <h4>
                          <strong>Precio total para el salón:</strong>
                          ${(costoPorPersona * peopleCount).toLocaleString()} MXN
                        </h4>
                      </div>

                      <div className="right-column">
                        {tarifas && tarifas.length > 0 && (
                          <div className="tarifas-section">
                            <h4><strong>Tarifas por cantidad de personas:</strong></h4>
                            <table className="tarifas-table">
                              <thead>
                                <tr>
                                  <th>Personas mín.</th>
                                  <th>Personas máx.</th>
                                  <th>Costo por persona</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tarifasOrdenadas.map((tarifa, idx) => (
                                  <tr key={idx}>
                                    <td>{tarifa.cantidadMinima}</td>
                                    <td>{tarifa.cantidadMaxima}</td>
                                    <td>${tarifa.costoPorPersona} MXN</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>

                    </div>

                    <p className="pricing-note">
                      Este paquete tiene un costo base de ${costoPorPersona} MXN por persona,
                      con un mínimo de {minPersonas} personas.
                      Si decides invitar a más personas, ajustaremos el costo total según el número definitivo de asistentes,
                      hasta un máximo de {maxPersonas} personas.
                    </p>
                  </div>
                )
              )}


            {openSections.includes(index) && (
              <div className="additional-sections">
                {setServicesData.serviciosIncluidos ? (
                <div className="top-sections">

                  {["serviciosIncluidos"].map((serviceKey, idx) => {
                    const items = setServicesData[serviceKey] || [];

                    const categorizedServices = items.filter(item => typeof item === "object");
                    const uncategorizedServices = items.filter(item => typeof item === "string");

                    return (
                      <div key={serviceKey} className={`sub-section col-${(idx % 3) + 1}`}>
                      {minPersonas === 0 ? (
                        <h3 className="capitalize-first-letter">
                          <strong>Servicios</strong>
                        </h3>
                      ) : (
                        <h3 className="capitalize-first-letter">
                          <strong>{capitalizeFirstLetter(serviceKey.replace(/([A-Z])/g, " $1"))}</strong>
                        </h3>
                      )}

                        {items.length === 0 ? (
                            <p>No hay información disponible en esta sección.</p>
                        ) : (
                          <div>
                            {categorizedServices.map(category => (
                              <div key={category.id} className="category-section">
                                <h4>{category.nombre}</h4>
                                <List items={category.servicios} itemType="servicio" />
                              </div>
                            ))}

                            {uncategorizedServices.length > 0 && (
                              <div className="category-section">
                                <h4>Servicios</h4>
                                <List items={uncategorizedServices} itemType="servicio" />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Sección: "serviciosComida" en la segunda columna */}
                  <div className="sub-section col-2">
                    <h3 className="capitalize-first-letter">
                      <strong>Servicios Comida</strong>
                    </h3>
                    {setServicesData["serviciosComida"]?.length === 0 ? (
                      <p>No hay información disponible en esta sección.</p>
                    ) : (
                      <List items={setServicesData["serviciosComida"]} itemType="serviciosComida" />
                    )}
                  </div>

                  <div className="sub-section col-3">
                    {["promocionesPaquete", "serviciosRecomendados"].map(serviceKey => {
                      const items = setServicesData[serviceKey] || [];

                      return (
                        <div key={serviceKey} className="grouped-section">
                          <h3 className="capitalize-first-letter">
                            <strong>{capitalizeFirstLetter(serviceKey.replace(/([A-Z])/g, " $1"))}</strong>
                          </h3>
                          {items.length === 0 ? (
                            <p>No hay información disponible en esta sección.</p>
                          ) : (
                            // 🔹 Aquí corregimos el `itemType` para que sea dinámico
                            <List items={items} itemType={serviceKey} />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                ) : (
                  <p>No hay información disponible</p>
                )}

                {minPersonas !== 0 && (
                  <div className="menu-section-bottom">
                    {comidas && comidas.length > 0 ? (
                      <MenuSection comidas={comidas} />
                    ) : (
                      <p>No hay información disponible en el menú.</p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
